import React from 'react';
import NavLink from './NavLink';
import NavLogoutLink from './NavLogoutLink';
import type { User } from '../../../types';

type Props = {
  isAdmin?: boolean,
  isOwner?: boolean,
  isClient?: boolean,
  selectedUser?: User,
  onPayrollGeneratorClick?: Function,
  onMarketingStatsClick?: Function,
}
const NavLinks = (props: Props): React.ReactElement => {
  const { isAdmin, isOwner, isClient, selectedUser, onPayrollGeneratorClick, onMarketingStatsClick } = props;

  return (
    <>
      {!isClient && <NavLink label="Calendar" link="/" />}
      {!isClient && <NavLink label="Desk booking" link="/desks" />}
      {isOwner || isAdmin ? <NavLink label="Projects" link="/projects" /> : null}
      {isOwner || isAdmin ? <NavLink label="Incidents" link="/incidents" /> : null}
      {isOwner || isAdmin ? <NavLink label="Categories" link="/categories" /> : null}
      {isOwner || isAdmin ? <NavLink label="Reports" link="/reports" /> : null}
      {isOwner || isAdmin ? <NavLink label="Users" link="/admin/users" /> : null}
      {isOwner || isAdmin ? <NavLink label="Check-ins" link="/admin/work_sessions/users" /> : null}
      {isOwner || isAdmin ? <NavLink label="Notifications" link="/notifications" /> : null}
      {isOwner || isAdmin ? <NavLink label="Dates" link="/date-management" /> : null}
      {isOwner || isAdmin ? <NavLink label="Subscriptions" link="/email-subscriptions" /> : null}
      <NavLink label="URL Shortener" link="/shortened_urls" reload />

      {(isOwner || isAdmin) && selectedUser ? (
        <li className={'dropdown-item nav-item'}>
          <a
            href={`/admin/users/${selectedUser.id}/export_evr`}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
          >
            Export ERV
          </a>
        </li>
      ) : null}
      {(isOwner || isAdmin) && (
        <li className={'dropdown-item nav-item'}>
          <a
            href="#"
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              onPayrollGeneratorClick?.();
            }}
          >
            Generate Payroll
          </a>
        </li>
      )}
      {(isOwner || isAdmin) && (
        <li className={'dropdown-item nav-item'}>
          <a
            href="#"
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              onMarketingStatsClick?.();
            }}
          >
            Export Marketing Statistics
          </a>
        </li>
      )}
      {isClient && <NavLink label="Dashboard" link="/client" />}
      <NavLink label="My profile" link="/profile" />
      <NavLogoutLink />
    </>
  );
};

export default NavLinks;
